<app-smartsupp [username]="smartsuppUsername" [name]="localUser.name" alignX="right"></app-smartsupp>
<div class="container" *ngIf="isLoaded">
  <div class="login-top-logo"></div>
  <div class="white-content-wrapper" id="white-content-wrapper">
    <div class="row no-gutters start-checking-block" id="start-checking-block" *ngIf="!isTestsRunning">
      <div class="col-7 d-flex flex-column p-3">
        <h3 class="title"><span>RSM-ONLINE</span>CLASSROOM DIAGNOSTICS</h3>
        <p>We need to check your computer in order to be sure everything works properly!</p>
        <div class="text-center mb-4">
          <button class="btn btn-primary checking-now-btn" (click)="runTests()">Start Checking Now</button>
        </div>
        <div>
          <h5 class="font-size-14 font-weight-600">If anything goes wrong</h5>
          <ul class="styled-list list-unstyled">
            <li>You can contact our technical support using the blue widget in the lower right-hand corner.</li>
            <li>If tech support is offline, you can use the widget to send us a message, and we will get back to you as
              soon as possible.
            </li>
          </ul>
        </div>
      </div>
      <div class="col-5 container-right-img"></div>
    </div>
    <div *ngIf="isTestsRunning" id="diagnostics_tabs_wrapper" class="p-3">
      <h3 class="title"><span>RSM-ONLINE</span>CLASSROOM DIAGNOSTICS</h3>
      <div class="panel panel-primary">
        <div class="panel-body" id="prep">
          <div id="checkup">
            <table>
              <tr>
                <td id="checkup-container"></td>
                <td id="video-container"></td>
              </tr>
            </table>
            <table class="tab-panel">
              <tbody>
              <tr>
                <!--step buttons-->
                <td style="vertical-align: top;">
                  <table class="tab-bar" role="tablist" style="width: 100%;">
                    <tbody>
                    <tr>
                      <td height="100%" class="tab-bar-first-wrapper" style="vertical-align: bottom;">
                        <div class="tab-bar-first" style="white-space: normal; height: 100%;">&nbsp;</div>
                      </td>
                      <ng-container *ngFor="let item of itemsArray,index as i">
                        <td *ngIf="!item.isHidden" (click)="switchTestManager(i)"
                          class="tab-bar-item-wrapper {{item.icon}}"
                          [ngClass]="{'tab-bar-item-wrapper-selected': i === viewStepIndex,'disabled': item.isDisabled}"
                          style="vertical-align: bottom;">
                          <div tabindex="0" class="tab-bar-item tab-bar-item-selected" role="tab">
                            <input type="text" tabindex="-1" role="presentation"
                              style="opacity: 0; height: 1px; width: 1px; z-index: -1; overflow: hidden; position: absolute;">
                            <div class="label tabItem {{item.icon}}"
                              [ngClass]="{'status-failed':item.isAtLeastOneTestFail,'status-passed': item.testsPassState === testPassState.PASSED}"
                              id="{{item.icon}}-item" title="{{item.name}}">
                            </div>
                          </div>
                        </td>
                      </ng-container>
                      <td class="tab-bar-rest-wrapper" style="vertical-align: bottom;">
                        <div class="tab-bar-rest" style="white-space: normal; height: 100%;"></div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td height="100%" style="vertical-align: top;">
                  <div class="tab-panel-bottom py-2 px-3" role="tabpanel">
                    <!--check if user not in summary tab-->
                    <div *ngIf="viewStepIndex !== itemsArray.length - 1" style="width: 100%; height: 100%; padding: 0; margin: 0;">
                      <div class="label tab-label-g screen-g" id="screen-g" style="width: 100%; height: 100%;">
                        <div id="screen-g-steps" class="test-steps-wrapper">
                          <!--steps main layout-->
                          <ng-container *ngFor="let infoItems of itemsArray[viewStepIndex].steps,index as i">
                            <div *ngIf="!infoItems.isHidden" style="display: inline-block;" class="step">
                              {{infoItems.name}}
                              <div class="loader-wrapper" *ngIf="!infoItems.testResult.text && i === itemsArray[viewStepIndex].currentStepIndex">
                                <span class="circle_1"></span>
                                <span class="circle_2"></span>
                                <span class="circle_3"></span>
                                <span class="circle_4"></span>
                              </div>
                              <div class="step-text" [ngClass]="{'color-red': infoItems.testResult.status === testPassState.FAILED}">{{infoItems.testResult.text}}</div>
                            </div>
                          </ng-container>
                        </div>
                        <!--Case when we show summary button after retake test-->
                        <div *ngIf="viewStepIndex !== this.itemsArray.length -1">
                          <div *ngIf="itemsArray[viewStepIndex].testsPassState === testPassState.PASSED && viewStepIndex < itemsArray.length - 1"
                            id="tab-test-msg-wrapper-screen-g" class="tab-test-msg-wrapper">
                            <div class="test-msg font-size-24 text-center color-green"><span class="test-msg-icon"></span><span>TEST PASSED</span></div>
                            <div class="test-msg font-size-24 text-center color-green">
                              <button *ngIf="itemsArray[viewStepIndex].needToShowSummaryButton && isAllTestsFinished" type="button" class="btn btn-primary mx-1"
                                style="width: 170px;"
                                (click)="backToSummary(itemsArray.length-1,viewStepIndex)">Back to Summary
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].isPreparedForTest &&
                    !itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].isHidden && !(itemsArray[viewStepIndex].testsPassState === testPassState.FAILED || itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testResult.status === testPassState.FAILED)" class="step-related-msg">
                      <div class="step-buttons-group">
                        <ng-container *ngIf="viewStepIndex === Steps.AUDIO && itemsArray[viewStepIndex].currentStepIndex === 1; else checkingCamera">
                          <div class="text-sm text-center mb-3">{{itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.text}}</div>

                          <div style="margin: 10px">
                            <label class="mr-2">Speaker:</label>
                            <select style="width: 250px !important" class="custom-select w-auto d-inline-block" [value]="selectedSpeakerId" (change)="onSelectSpeaker($event.target.value)">
                              <option *ngFor="let dev of audioOutputDevices" [selected]="selectedSpeakerId === dev.deviceId" [value]="dev.deviceId">{{dev.label || ('Speaker ' + dev.deviceId)}}</option>
                            </select>
                          </div>

                          <button (click)="handleTestPreparationQuestionClick(answerOption.value)"
                                  *ngFor="let answerOption of itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.answerOptions"
                                  class="btn {{answerOption.value !== 'yes'? 'btn-outline-primary' : 'btn-primary'}} mx-1"
                                  [disabled]="answerOption.isBlock" [hidden]="answerOption.isDisabled">
                            {{answerOption.text}}
                          </button>
                        </ng-container>

                        <ng-template #checkingCamera>
                          <ng-container *ngIf="viewStepIndex === Steps.VIDEO && itemsArray[viewStepIndex].currentStepIndex === 1; else checkingMicrophone">
                            <div class="text-sm text-center mb-3">{{itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.text}}</div>

                            <div style="margin: 10px">
                              <label class="mr-2">Camera:</label>
                              <select style="width: 250px !important" class="custom-select w-auto d-inline-block" [value]="selectedCamId" (change)="onSelectCamera($event.target.value)">
                                <ng-container *ngFor="let dev of videoInputDevices">
                                  <option (click)="onSelectCamera(dev.id)" *ngIf="dev.id !== ''" [selected]="selectedCamId === dev.id" [value]="dev.id">{{dev.label || ('Camera ' + dev.id)}}</option>
                                </ng-container>
                              </select>
                            </div>

                            <div class="row justify-content-center mt-4">
                              <div class="col-auto">
                                <div #videoWrapper id="video"></div>
                              </div>

                              <div class="col-4">
                                <button (click)="handleTestPreparationQuestionClick(answerOption.value)"
                                        *ngFor="let answerOption of itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.answerOptions"
                                        class="btn d-block mb-3 w-100 {{answerOption.value !== 'yes'? 'btn-outline-primary' : 'btn-primary'}} mx-1"
                                        [disabled]="answerOption.isBlock">
                                  {{answerOption.text}}
                                </button>
                              </div>
                            </div>
                          </ng-container>
                        </ng-template>

                        <ng-template #checkingMicrophone>
                          <ng-container *ngIf="viewStepIndex === Steps.MIC; else general">
                            <div class="text-sm text-center mb-3">{{itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.text}}</div>

                            <div style="margin: 10px">
                              <label class="mr-2">Microphone:</label>
                              <select style="width: 250px !important" class="custom-select w-auto d-inline-block" [value]="selectedMicId" (change)="onSelectMicrophone($event.target.value)">
                                <option *ngFor="let dev of audioInputDevices" [selected]="selectedMicId === dev.id" [value]="dev.id">{{dev.label || ('Microphone ' + dev.id)}}</option>
                              </select>
                            </div>

                            <div>
                              <div *ngIf="viewStepIndex === Steps.MIC" class="d-flex justify-content-center">
                                <div class="voice-meter">
                                  <div class="voice-fill" [style.width]="micValue * 100 + '%'"></div>
                                </div>
                              </div>
                            </div>

                            <button (click)="handleTestPreparationQuestionClick(answerOption.value)"
                                    *ngFor="let answerOption of itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.answerOptions"
                                    class="btn {{answerOption.value !== 'yes'? 'btn-outline-primary' : 'btn-primary'}} mx-1"
                                    [disabled]="answerOption.isBlock">
                              {{answerOption.text}}
                            </button>
                          </ng-container>
                        </ng-template>

                        <ng-template #general>
                          <div class="text-sm text-center mb-3">{{itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.text}}</div>
                          <button (click)="handleTestPreparationQuestionClick(answerOption.value)"
                                  *ngFor="let answerOption of itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testQuestion.answerOptions"
                                  class="btn {{answerOption.value !== 'yes'? 'btn-outline-primary' : 'btn-primary'}} mx-1"
                                  [disabled]="answerOption.isBlock" [hidden]="answerOption.isDisabled">
                            {{answerOption.text}}
                          </button>
                        </ng-template>
                      </div>
                    </div>

                    <audio #audioTest src="{{ audioFilePath }}" type="audio/mpeg"
                           *ngIf="(itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].name === 'Audio playback'
                           || itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].name ==='Audio source')
                     && itemsArray[viewStepIndex].testsPassState === testPassState.PENDING " loop autoplay>
                    </audio>

                    <div *ngIf="( itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testResult.status === testPassState.PENDING &&
                      itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].name === 'Turning camera and mic on')"
                      class="step-related-msg"><span class="text-sm">Click 'Allow' button on top of the page...</span>
                    </div>
                    <!--check if user not in summary page-->
                    <div *ngIf="viewStepIndex !== this.itemsArray.length -1">
                      <div *ngIf="itemsArray[viewStepIndex].testsPassState === testPassState.FAILED ||
                        itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testResult.status === testPassState.FAILED"
                        id="tab-test-msg-wrapper-networkSpeed-g2" class="tab-test-msg-wrapper">
                        <div class="test-msg fail-msg font-size-18 text-center color-red"><span class="test-msg-icon"></span><span>TEST NOT PASSED</span></div>
                        <div class="retry-skip-wrapper">
                          <div class="retry-skip-container text-center mb-3">
                            <button type="button" (click)="retry(viewStepIndex)" class="btn btn-primary mx-1">Retry</button>
                            <button type="button" (click)="skip()"
                              *ngIf="!itemsArray[viewStepIndex].isSkipped || runningStepIndex === viewStepIndex"
                              class="btn btn-primary mx-1">Skip
                            </button>
                            <button *ngIf="itemsArray[viewStepIndex].isSkipped && isAllTestsFinished"
                              (click)="backToSummary(itemsArray.length-1,viewStepIndex)"
                              type="button" class="btn btn-primary mx-1"
                              style="width: 170px;">Back to Summary
                            </button>
                          </div>
                        </div>
                        <div class="fail-details text-center">{{itemsArray[viewStepIndex].steps[itemsArray[viewStepIndex].currentStepIndex].testResult.errorMassage}}</div>
                      </div>
                    </div>

                    <!--check if user is in summary tab-->
                    <div *ngIf="viewStepIndex === itemsArray.length - 1" class="summary-g pt-4">
                      <div class="row g-3 mb-3">
                        <div class="col-sm-6">
                          <ng-container *ngFor="let items of itemsArray,index as i">
                              <ul class="summary-list list-unstyled" *ngIf="i < 4 && !items.isHidden">
                                <li><h4>{{items.name}}</h4></li>
                                <li class="clearfix row" *ngFor="let infoItems of items.steps">
                                  <div *ngIf="!infoItems.isHidden" class="col-sm"> {{infoItems.name}}
                                    <button *ngIf="infoItems.testResult.status===testPassState.FAILED"
                                      type="button" (click)="retry(i)" class="btn btn-link p-0 ml-2">Retry test
                                    </button>
                                  </div>
                                  <div [ngClass]="{'color-red':infoItems.testResult.status === testPassState.FAILED}"
                                    class="col-sm-auto text-right">{{infoItems.testStatus}}</div>
                                </li>
                              </ul>
                          </ng-container>
                        </div>
                        <div class="col-sm-6">
                          <ng-container *ngFor="let items of itemsArray,index as i">
                              <ul class="summary-list list-unstyled" *ngIf="i >= 4 && items.name && !items.isHidden">
                                <li><h4>{{items.name}}</h4></li>
                                <li class="clearfix row" *ngFor="let infoItems of items.steps">
                                  <div *ngIf="!infoItems.isHidden" class="col-sm"> {{infoItems.name}}
                                    <button *ngIf="infoItems.testResult.status===testPassState.FAILED"
                                      type="button" (click)="retry(i)" class="btn btn-link p-0 ml-2">Retry test
                                    </button>
                                  </div>
                                  <div [ngClass]="{'color-red':infoItems.testResult.status === testPassState.FAILED}"
                                    class="col-sm-auto text-right">{{infoItems.testStatus}}</div>
                                </li>
                                <li class="clearfix row" *ngIf="isSpeakerItem(items)">
                                  <div class="col-sm"> Tested speaker</div>
                                  <div class="col-sm-auto text-right" style="width: 200px"> {{ selectedSpeaker()?.label || 'Unknown' }} </div>
                                </li>
                                <li class="clearfix row" *ngIf="isCameraItem(items)">
                                  <div class="col-sm"> Tested camera</div>
                                  <div class="col-sm-auto text-right" style="width: 200px"> {{ selectedCamera()?.label || 'Unknown' }} </div>
                                </li>
                                <li class="clearfix row" *ngIf="isMicrophoneItem(items)">
                                  <div class="col-sm"> Tested microphone</div>
                                  <div class="col-sm-auto text-right" style="width: 200px"> {{ selectedMicrophone()?.label || 'Unknown' }} </div>
                                </li>
                              </ul>
                          </ng-container>
                        </div>
                      </div>

                      <div *ngIf="!isAllTestsSucceed" class="step-related-msg mb-3">
                        <div class="text-sm color-red text-center">Once you log in, please ask tech support for help with those steps of the diagnostics that did not succeed,if you have not done so yet.</div>
                      </div>
                      <div *ngIf="classroom.roomNum !== 0" id="navigate_button" class="text-center">
                        <button class="btn btn-primary" role="button" (click)="goToClassroom()">Go to classroom</button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div style="display:none; font-size: 14px;  padding:4px 0 8px; color: #555; font-style: italic; ">
        <br/>
        In case of any technical problems that you cannot resolve using this guide, please email your question to
        <a style="color: #77b;" href="mailto:online.techsupport@russianschool.com?Subject=Virtual%20Classroom">online.techsupport@russianschool.com</a>.
      </div>
    </div>
  </div>
</div>

<div id="msg"></div>
